import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {SharedModule} from '@app/shared/shared.module';

import {FaqComponent} from "./faq/faq.component";
import {HelpcenterComponent} from "./helpcenter/helpcenter.component";
import {SearchComponent} from "./search/search.component";
import {NgxSelectModule} from 'ngx-select-ex';
import {PageContentComponent} from "./pagecontent/pagecontent.component";
import {PageContentAdminComponent} from "./pagecontentadmin/pagecontentadmin.component";
import {FaqAdminComponent} from "./faqadmin/faqadmin.component";
import {NgxSmartModalModule} from 'ngx-smart-modal';
import {SectionComponent} from "./faqadmin/section/section.component";
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
import {ProgressbarModule} from 'ngx-bootstrap/progressbar';
import {FunctionsComponent} from '@app/routes/help/pagecontentadmin/functions/functions.component';
import {FunctionSelectComponent} from '@app/routes/help/pagecontentadmin/functions/function-select/function-select.component';
import {DataTypeFilter} from "@app/shared/pipes/data-type.filter";

const routes: Routes = [
  {path: 'search', component: SearchComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'helpcenter', component: HelpcenterComponent},
  {path: 'pagecontent', component: PageContentComponent},
  {path: 'pagecontentadmin', component: PageContentAdminComponent},
  {path: 'faqadmin', component: FaqAdminComponent}
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    NgxSelectModule,
    NgxSmartModalModule.forRoot(),
    ProgressbarModule.forRoot(),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot()
  ],
  declarations: [
    SearchComponent,
    FaqComponent,
    HelpcenterComponent,
    PageContentComponent,
    PageContentAdminComponent,
    FaqAdminComponent,
    SectionComponent,
    FunctionsComponent,
    FunctionSelectComponent
  ],
  exports: [
    RouterModule
  ]
})
export class HelpModule {
}

